import { render, staticRenderFns } from "./CustomerTipComplete.vue?vue&type=template&id=28250dec"
import script from "./CustomerTipComplete.vue?vue&type=script&lang=js"
export * from "./CustomerTipComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports